import { Component } from 'react';
import withBreakpoint from './withBreakpoint';

class ShowAtBreakpoint extends Component {
  render() {
    const {
      breakpoints,
      breakpoint
    } = this.props;
    const matchedBreakpoint = breakpoints[breakpoint];
    return matchedBreakpoint ? this.props.children : null;
  }

}

export default withBreakpoint(ShowAtBreakpoint);